// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCLypm40MZ8T4KgJBrTxmOIfXwvbgWNa8s',
    authDomain: 'dianet-web-angular-6-a9850.firebaseapp.com',
    databaseURL: 'https://dianet-web-angular-6-a9850.firebaseio.com',
    projectId: 'dianet-web-angular-6-a9850',
    storageBucket: 'dianet-web-angular-6-a9850.appspot.com',
    messagingSenderId: '645745039508'
  },
  hostingUrl: 'https://dianet-web-angular-6-a9850.firebaseapp.com',
  functionsUrl: 'https://us-central1-dianet-web-angular-6-a9850.cloudfunctions.net'
};
